import { i18n, defaultNS, flattenResources } from "@whatslly/commons/i18nService";

i18n.addResources(
  "en",
  defaultNS,
  flattenResources({
    settings_terms: "Terms of Use",
    settings_privacy: "Privacy",
    settings_about: "About",
    settings_support: "Support",
    settings_logout: "Logout",
    copied_to_clipboard: "Copied to clipboard",
    lang_switch: {
      language: "Language",
      english: "English",
      portuguese: "Portuguese",
      spanish: "Spanish",
      back: "Back",
      cancel: "Cancel",
    },
    edit_user: {
      select: "Select...",
      title: "Edit User",
      save: "Save changes",
      success: "User updated successfully",
      username: "Username",
      phone: "Phone",
      email: "Email",
      first_name: "First Name",
      last_name: "Last Name",
      manager: "Manager",
      wa_notification_section: "WhatsApp notification sound",
      wa_notification_choose: "Custom WhatsApp notification sound…",
      wa_notification_current: "Current",
      wa_notification_value_default: "WhatsApp default",
      wa_notification_custom_untitled: "Custom sound",
      wa_notification_choose_file: "Choose audio file",
      wa_notification_loading: "Loading…",
      wa_notification_clear: "Remove custom sound",
      wa_notification_saved: "Custom notification sound saved. It applies to new messages in WhatsApp Web.",
      wa_notification_cleared: "Notification sound reset to WhatsApp default.",
      wa_notification_too_large: "File is too large. Choose an audio file under 5 MB.",
      wa_notification_invalid_format: "Unsupported audio format. Use MP3, WAV, OGG, M4A, or AAC.",
      wa_notification_sync_failed: "Could not update the sound in WhatsApp Web. Open a WhatsApp Web tab and try again.",
    },
  })
);
i18n.addResources(
  "es",
  defaultNS,
  flattenResources({
    settings_terms: "Términos de Uso",
    settings_privacy: "Privacidad",
    settings_about: "Acerca de",
    settings_support: "Soporte",
    settings_logout: "Cerrar sesión",
    copied_to_clipboard: "Copied to clipboard",
    lang_switch: {
      language: "Idioma",
      english: "Inglés",
      portuguese: "Portugués",
      spanish: "Español",
      back: "Volver",
      cancel: "Cancelar",
    },
    edit_user: {
      select: "Seleccionar...",
      title: "Editar Usuario",
      save: "Guardar cambios",
      success: "Usuario actualizado con éxito",
      username: "Usuario",
      phone: "Teléfono",
      email: "Email",
      first_name: "Nombre",
      last_name: "Apellido",
      manager: "Gerente",
      wa_notification_section: "Sonido de notificación de WhatsApp",
      wa_notification_choose: "Sonido de notificación de WhatsApp…",
      wa_notification_current: "Actual",
      wa_notification_value_default: "Predeterminado de WhatsApp",
      wa_notification_custom_untitled: "Sonido personalizado",
      wa_notification_choose_file: "Elegir archivo de audio",
      wa_notification_loading: "Cargando…",
      wa_notification_clear: "Quitar sonido personalizado",
      wa_notification_saved: "Sonido de notificación guardado. Se aplicará a los mensajes nuevos en WhatsApp Web.",
      wa_notification_cleared: "Sonido de notificación restablecido al predeterminado de WhatsApp.",
      wa_notification_too_large: "El archivo es demasiado grande. Elige un archivo de audio de menos de 5 MB.",
      wa_notification_invalid_format: "Formato de audio no compatible. Usa MP3, WAV, OGG, M4A o AAC.",
      wa_notification_sync_failed: "No se pudo actualizar el sonido en WhatsApp Web. Abre una pestaña de WhatsApp Web e inténtalo de nuevo.",
    },
  })
);
i18n.addResources(
  "pt",
  defaultNS,
  flattenResources({
    settings_terms: "Termos de Uso",
    settings_privacy: "Privacidade",
    settings_about: "Sobre",
    settings_support: "Suporte",
    settings_logout: "Sair",
    copied_to_clipboard: "Copiado para a área de transferência",
    lang_switch: {
      language: "Idioma",
      english: "Inglês",
      portuguese: "Português",
      spanish: "Espanhol",
      back: "Voltar",
      cancel: "Cancelar",
      login_provider: "Login Provider",
    },
    edit_user: {
      select: "Selecione...",
      title: "Editar Usuário",
      save: "Salvar alterações",
      success: "Usuário atualizado com sucesso",
      username: "Usuário",
      phone: "Telefone",
      email: "Email",
      first_name: "Nome",
      last_name: "Sobrenome",
      manager: "Gerente",
      wa_notification_section: "Som de notificação do WhatsApp",
      wa_notification_choose: "Som de notificação do WhatsApp…",
      wa_notification_current: "Atual",
      wa_notification_value_default: "Padrão do WhatsApp",
      wa_notification_custom_untitled: "Som personalizado",
      wa_notification_choose_file: "Escolher arquivo de áudio",
      wa_notification_loading: "Carregando…",
      wa_notification_clear: "Remover som personalizado",
      wa_notification_saved: "Som de notificação salvo. Aplica-se a novas mensagens no WhatsApp Web.",
      wa_notification_cleared: "Som de notificação restaurado para o padrão do WhatsApp.",
      wa_notification_too_large: "Arquivo grande demais. Escolha um arquivo de áudio com menos de 5 MB.",
      wa_notification_invalid_format: "Formato de áudio não suportado. Use MP3, WAV, OGG, M4A ou AAC.",
      wa_notification_sync_failed: "Não foi possível atualizar o som no WhatsApp Web. Abra uma aba do WhatsApp Web e tente novamente.",
    },
  })
);

export default i18n;
